const marmitekElem = document.querySelector('.marmitek-anouncement .marmitek-anouncement--items');
let marmitekFlickityInstance;

const initMarmitekFlickity = () => {
    marmitekFlickityInstance = new Flickity(marmitekElem, {
        prevNextButtons: false,
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        autoPlay: true
    });
};

const destroyMarmitekFlickity = () => {
    if (marmitekFlickityInstance) {
        marmitekFlickityInstance.destroy();
        marmitekFlickityInstance = null;
    }
};

const handleMarmitekResize = () => {
    initMarmitekFlickity();
};

document.addEventListener('DOMContentLoaded', function () {
    initMarmitekFlickity();
    window.addEventListener('resize', handleMarmitekResize);
});